import { request } from '@umijs/max';

export async function polishPrompt(params: {
  text: string;
  scope?: string;
  modelKey?: string;
  style?: string;
}) {
  const res = await request<any>('/api/qn/prompts/polish', {
    method: 'POST',
    data: params,
  } as any);
  const body = (res?.data ?? res) as any;
  if (body?.success === true && 'data' in body) {
    return body.data as string;
  }
  if (typeof body === 'string') return body;
  return String(body?.data ?? '');
}

